import { createSelector } from '@ngrx/store';
import {
  getCalendarState,
  getCurrentDayState,
} from '@fc-shared/ui/shcedule-calendar/store/schedule-calendar.reducer';

export const getCurrentDay = createSelector(
  getCalendarState,
  getCurrentDayState,
);
